import _slicedToArray from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { IconButton as s } from "@box/blueprint-web";
import { Pencil as L, LinkBroken as P } from "@box/blueprint-web-assets/icons/Fill";
import { useEffect as S, useCallback as h } from "react";
import { useIntl as x } from "react-intl";
import { usePropSyncedState as U } from "../hooks/usePropSyncedState.js";
import { messages as a } from "../messages.js";
import { tryPrependProtocol as j } from "../utils/protocoled-url.js";
import { EditLink as v } from "./edit-link.js";
import { ReadLink as M } from "./read-link.js";
import { jsx as i, jsxs as p, Fragment as F } from "react/jsx-runtime";

var K = function K(_ref) {
  var f = _ref.initialUrl,
      u = _ref.isReadonly,
      k = _ref.children,
      r = _ref.isEditing,
      e = _ref.setIsEditing,
      m = _ref.onSubmit,
      o = _ref.onClear,
      t = _ref.onEditChange;

  var n = x(),
      _U = U(f),
      _U2 = _slicedToArray(_U, 2),
      c = _U2[0],
      d = _U2[1];

  S(function () {
    t == null || t(r);
  }, [r, t]);

  var b = function b() {
    return e(!0);
  },
      y = h(function (B) {
    e(!1);
    var l = j(B.trim());
    d(l), m(l);
  }, [m]);

  return r ? /* @__PURE__ */i(v, {
    initialUrl: c,
    onSubmit: y
  }) : /* @__PURE__ */p(M, {
    url: c,
    children: [!u && /* @__PURE__ */p(F, {
      children: [/* @__PURE__ */i(s, {
        "aria-label": n.formatMessage(a.editButton),
        "data-testid": "edit-hyperlink-button",
        icon: L,
        onClick: b,
        variant: "high-contrast"
      }), /* @__PURE__ */i(s, {
        "aria-label": n.formatMessage(a.unlinkButton),
        "data-testid": "clear-hyperlink-button",
        icon: P,
        onClick: function onClick() {
          return o == null ? void 0 : o();
        },
        variant: "high-contrast"
      })]
    }), k]
  });
};

export { K as HyperlinkEditor };